import Vue from 'vue';
import LoadingScreen from 'components/loading-screen.vue';

Vue.config.productionTip = false;
Vue.config.devtools = __DEV__ || __STAGING__;
Vue.config.silent = !__DEV__;

window.playClickNotReady = () => {
  if (!window.ga) return;

  const timestamp = (window.performance && window.performance.now)
    ? window.performance.now()
    : new Date().getTime();

  window.ga('send', 'event', 'metrics', 'not_ready_play_click', 'timing',
    timestamp, { nonInteraction: true });
};

const button = document.querySelector('#loading-screen .btn');
if (button) {
  button.addEventListener('mousedown', window.playClickNotReady, false);
  button.addEventListener('touchstart', window.playClickNotReady, false);
}

// tslint:disable-next-line variable-name
const LoadingScreenApp = Vue.extend(LoadingScreen);
const vue = new LoadingScreenApp();
vue.$mount('#loading-screen', true);
